export const analytics = {
  ANALYTICS_STAGING: 'https://staging-v2.inplayer.com/analytics/persa',
  ANALYTICS_PRODUCTION: 'https://services.inplayer.com/analytics/persa',
};
